import React, { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthCtx = createContext(null);

// SECURITY: Do NOT store tokens in localStorage (XSS-exfil risk).
// Auth uses httpOnly + Secure + SameSite=Lax cookies only.
// Clean up any legacy localStorage token from previous versions.
function purgeLegacyToken() {
  try { localStorage.removeItem("sentra_token"); } catch (e) { /* private mode */ }
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    purgeLegacyToken();
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch (err) {
        // 401 is expected when user is not logged in; log any other errors
        if (err?.response?.status && err.response.status !== 401) {
          console.error("Auth check failed", err);
        }
        setUser(null);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      console.error("Logout API failed (continuing anyway)", err);
    }
    purgeLegacyToken();
    setUser(null);
  };

  const refresh = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
    return data;
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, refresh, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);

export function formatError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Něco se pokazilo, zkus to znovu.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return JSON.stringify(d);
}
